import React from 'react';
import { View } from 'react-native';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, useFormSubmit } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Notice } from 'app/src/elements/Notice';
import { Title } from 'app/src/styles';
import { useNavigate, useOutletContext } from 'app/src/utils/routing';

import { UPDATE_CLIENT } from './queries';
import { FIELDS } from './new';

const Client = () => {
  const navigate = useNavigate();
  const { client } = useOutletContext();

  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource: client })
  });

  const { submit: updateClient, formStatus, errorMessage } =
    useFormSubmit(UPDATE_CLIENT, {
      onCompleted: () => navigate('/clients'),
    });

  const onSubmit = input => {
    updateClient({ variables: { input: { id: client.id, ...input } } });
  };

  return (
    <View>
      <Title>{client.name}</Title>

      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      {errorMessage && <Notice type="error">{errorMessage}</Notice>}

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default Client;
